import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import type { DebugRow, DebugTab } from './BankAccountLifecycleDebugDrawer.types.ts';

export const isDebugTab = (value: string | null): value is DebugTab =>
	value === 'logs' || value === 'transitions';

export const fetchRows = async (
	endpointTemplate: string,
	bankAccountId: string
): Promise<DebugRow[]> => {
	const response = await makeRequest<ApiV1.Response<DebugRow[]>>({
		endpoint: formatUnicorn(endpointTemplate, { id: bankAccountId }),
		method: HTTP_METHOD.GET,
	});
	return response.payload ?? [];
};

export const rowHeadline = (row: DebugRow): string => {
	const parts = [row['trigger'], row['validationType'], row['verificationType'], row['result']]
		.filter((value): value is string => typeof value === 'string' && !!value)
		.join(' · ');
	return parts || String(row.id ?? '');
};
